// Import Dependencies
import { Container } from "components";
import config from "config/index.js";
import preset from "jss-preset-default";
import { CustomizationPage, SelectionPage } from "pages";
import React, { Component } from "react";
import IdleTimer from "react-idle-timer";
import { jss } from "react-jss";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
// Import styles
import BaseStyles from "styles/base";
import { customTheme } from "themeProvider";
import pjson from "../package.json";
import { di } from "./bottle";
import { exitBRPTV } from "./services/BRPTV";

// Use preset JSS plugins: https://github.com/cssinjs/jss-preset-default/blob/master/package.json#L50
jss.setup(preset());

// Styles
const styles = (theme) => ({
  app: {},
  fullFill: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
  },
  watermark: {
    position: "absolute",
    bottom: 9,
    left: 9,
    width: 32,
    height: 32,
  },
});

// Component
class App extends Component {
  constructor(props) {
    // Build number
    console.log(`[Build Number] ${pjson.version}`);

    // call base constructor
    super(props);

    // initialize state
    this.state = {
      lang: di.profileManager.lang,
      appLoading: true,
      sketchLoading: true,
    };
    // using region in methods
    this.region = undefined

    App.setPageData = App.setPageData.bind(this);

    this._initialize().then(() => {
      this.setState({
        ...this.state,
        appLoading: false
      })
    });
  }

  static setPageData() {
    // Send off analytics data to Adobe Data Layer
    if (typeof window !== "undefined") {
      window.appVersion = pjson.version;
    }
  }

  async _initialize() {
    // get query parameters
    const params = new URLSearchParams(window.location.search);
    let validLanguages;
    let regionParam;
    let playerID;
    let displayPrice

    if (params) {
      const languages = params.get("lang");
      validLanguages = languages.split(",");
      regionParam = params.get("region");
      playerID = params.get("playerID");
      displayPrice = params.get("displayPrice") === 'true';
    }
    // otherwise set default vales
    const allowedRegions = di.profileManager.allowedRegions

    validLanguages = validLanguages ? validLanguages : ["en"];
    this.region = regionParam && allowedRegions.includes(regionParam.toUpperCase()) ? regionParam.toUpperCase() : "GBL";
    playerID = playerID ? playerID : "10000000";
    
    console.log("[App] development", config.development);
    console.log("[App] valid languages", validLanguages);
    console.log("[App] region", regionParam);
    console.log("[App] playerID", playerID);

    // initialize managers
    await di.profileManager.initialize(
      validLanguages,
      this.region,
      playerID,
      window.location.search,
      displayPrice
    );
    await di.catalogManager.initialize();
    await di.garage.initialize();
  }

  onRef = (ref) => {
    this.iFrame = ref;
    
    this.sketchfabAPIUtility = new window.SketchfabAPIUtility(
      config.sketchfab.id[this.region],
      this.iFrame,
      {
        autostart: 1,
        autospin: 0,
        ui_infos: 0,
        ui_general_controls: 1,
        ui_settings: 0,
        ui_help: 0,
        ui_hint: 0,
        ui_stop: 0,
        ui_inspector: 0,
        ui_vr: 0,
        ui_fullscreen: 0,
        ui_watermark_link: 0,
        preload: 1,
      }
    );
    this.sketchfabAPIUtility.addEventListener(
      this.sketchfabAPIUtility.EVENT_INITIALIZED,
      this.onSketchfabUtilityReady
    );
    this.sketchfabAPIUtility.create();
  };

  onSketchfabUtilityReady = () => {
    this.sketchfabAPIUtility.removeEventListener(
      this.sketchfabAPIUtility.EVENT_INITIALIZED,
      this.onSketchfabUtilityReady
    );
    di.modelManager.initialize(this.sketchfabAPIUtility);
    di.modelManager.hideAllParts();

    // mark as loaded
    this.setState({
      ...this.state,
      sketchLoading: false
    });
  };

  onIdle = () => {
    // reset route to section screen
    this.router.history.push(
      `/selection?lang=${di.profileManager.allowedLanguages}`
    );

    console.log("[App] prolonged inactivity, switching back to BRP tv");

    exitBRPTV();
  };

  async componentWillMount() {
    // load content
    // await appContent.load();

    App.setPageData();
  }

  componentDidMount() {
    this.languageSubscription = di.profileManager.lang$.subscribe(
      async (lang) => {
        await this.setState({
          lang: lang,
        });

        await di.catalogManager.initialize();
      }
    );
  }

  componentWillUnmount() {
    this.languageSubscription.unsubscribe();
  }

  render() {
    const { classes } = this.props;

    console.log("[App] rendered language: ", this.state.lang);

    let loaderImage;
    if (this.state.lang === "fr") {
      loaderImage = require("./assets/images/French_Loader.gif");
    } else if (this.state.lang === "de") {
      loaderImage = require("./assets/images/German_Loader.gif");
    } else {
      loaderImage = require("./assets/images/English_Loader.gif");
    }
    console.log("[App] loading state app: ", this.state.appLoading);
    console.log("[App] loading state sketch: ", this.state.sketchLoading);
    return (
      <IdleTimer
        element={document}
        onIdle={this.onIdle}
        timeout={1000 * 60 * 5}
      >
        <Router ref={(ref) => (this.router = ref)}>
          <React.Fragment>
            {/* Core app styles + resets */}
            <BaseStyles />

            {/* Start of app */}
            {!this.state.appLoading && (<div className={classes.app}>
              <iframe
                ref={this.onRef}
                src=""
                id="api_frame"
                allowFullScreen={true}
                style={styles().fullFill}
              />

              <img
                src={require("./images/logo-sketchfab-01.png")}
                style={styles().watermark}
              />

              <div>
                <Redirect
                  from="/"
                  to={{ pathname: "selection", search: window.location.search }}
                />
                <Route path="/selection" component={SelectionPage} />
                <Route path="/customization" component={CustomizationPage} />
              </div>
            </div>)}

            {(this.state.sketchLoading || this.state.appLoading) && (
              <Container
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                  backgroundColor: "white",
                }}
              >
                <img
                  src={loaderImage}
                  style={{ width: "100%", height: "100%" }}
                />
              </Container>
            )}
          </React.Fragment>
        </Router>
      </IdleTimer>
    );
  }
}

export default customTheme(styles, App);



// WEBPACK FOOTER //
// ./src/App.js